import timJeskeImage from "@/assets/team/tim-jeske-new.png";

export type AuthorId = "moritz" | "tim";

export interface Author {
  id: AuthorId;
  name: string;
  role: string;
  linkedin: string;
  /** Kernthemen des Autors – für Autoren-Box und E-E-A-T-Signale. */
  topics: string[];
  /** Selbst gehostetes Portrait (400×400) für Autoren-Box und author.image-Schema. */
  image?: string;
  imageAlt?: string;
}

export const authors: Record<AuthorId, Author> = {
  moritz: {
    id: "moritz",
    name: "Moritz Tittler",
    role: "Head of Sales",
    linkedin: "https://www.linkedin.com/in/moritztittler/",
    topics: ["LinkedIn", "ABM", "Sales"],
    image: "/blog/autor-moritz-tittler.webp",
    imageAlt: "Moritz Tittler, Prometheus Marketing",
  },
  tim: {
    id: "tim",
    name: "Tim Jeske",
    role: "RevOps & HubSpot Lead",
    linkedin: "https://de.linkedin.com/in/tim-jeske",
    topics: ["HubSpot", "RevOps", "Tracking"],
    image: timJeskeImage,
    imageAlt: "Tim Jeske, RevOps & HubSpot Lead bei Prometheus Marketing",
  },
};

export function getAuthor(id: AuthorId): Author {
  return authors[id];
}
